export enum StatusAtendimentoColeta {
    PENDENTE = 'PENDENTE',
    INICIADO = 'INICIADO',
    REALIZADO = 'REALIZADO',
    CANCELADO = 'CANCELADO',
    FINALIZADO = 'FINALIZADO',
}